"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _AuthProvider = require("../../../AuthProvider");
var _GroupChats = require("../../../GroupChats");
var _utils = require("../../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AccountChatBanConfig = function AccountChatBanConfig(_ref) {
  var patientId = _ref.patientId,
    title = _ref.title;
  var _useChat = (0, _utils.useChat)(),
    chatClient = _useChat.chatClient;
  var _useAuth = (0, _AuthProvider.useAuth)(),
    user = _useAuth.user;
  var _usePatientPublicChat = (0, _utils.usePatientPublicChatBan)(patientId),
    bannedInPublicChannels = _usePatientPublicChat.banned,
    banExpiresAt = _usePatientPublicChat.banExpiresAt,
    loading = _usePatientPublicChat.loading,
    refetchMemberActiveBan = _usePatientPublicChat.refresh;
  if (!(0, _utils.isAdmin)(user) || !chatClient) {
    return null;
  }
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_spin.default, {
      className: "inline-block",
      size: "small"
    });
  }
  var mockGetStreamChannelMember = {
    user_id: patientId,
    banned: bannedInPublicChannels,
    user: {},
    ban_expires: banExpiresAt
  };
  return /*#__PURE__*/_react.default.createElement(_GroupChats.MemberChatBanConfig, {
    member: mockGetStreamChannelMember,
    chatUser: chatClient.user,
    showInfo: false,
    onChangeBan: refetchMemberActiveBan,
    title: title
  });
};
var _default = AccountChatBanConfig;
exports.default = _default;